'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = _interopDefault(require('react'));
var cx = _interopDefault(require('classnames'));
var PropTypes = _interopDefault(require('prop-types'));

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var styles = {"ethanol":"#fff","tandem":"#f4f5f5","chrome":"#d4d6d9","LFGray":"#9ea2a9","smokey":"#60646c","burnout":"#46494f","roadhog":"arrive_RadioButton__roadhog","axle":"#1d1e20","grease":"#0a0a0b","bandit":"#e0f3fb","bigSky":"#b1e1f5","arrive":"#2aaae2","blueBayou":"#039ddd","nightTime":"#007dbc","blueridge":"#0062c0","gasoline":"#feefcb","diesel":"#f1ae11","mileMarker":"#e8f5e9","gatorguts":"#4caf50","frogger":"#2b731a","whoaNelly":"#ffedf1","jackknife":"#cb2024","container":"arrive_RadioButton__container","button":"arrive_RadioButton__button","checked":"arrive_RadioButton__checked","label":"arrive_RadioButton__label","radio":"arrive_RadioButton__radio","invalid":"arrive_RadioButton__invalid","disabled":"arrive_RadioButton__disabled"};

var RadioButton = React.forwardRef(function (_ref, ref) {
  var _cx;

  var className = _ref.className,
      disabled = _ref.disabled,
      invalid = _ref.invalid,
      value = _ref.value,
      label = _ref.label,
      onChange = _ref.onChange,
      _ref$checked = _ref.checked,
      checked = _ref$checked === void 0 ? false : _ref$checked,
      _ref$asButton = _ref.asButton,
      asButton = _ref$asButton === void 0 ? false : _ref$asButton,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'ethanol' : _ref$theme;
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: cx(styles.container, className, styles[theme], (_cx = {}, _defineProperty(_cx, styles.checked, checked), _defineProperty(_cx, styles.button, asButton), _defineProperty(_cx, styles.invalid, invalid), _defineProperty(_cx, styles.disabled, disabled), _cx))
  }, /*#__PURE__*/React.createElement("input", {
    className: styles.radio,
    disabled: disabled,
    id: value,
    type: "radio",
    value: value,
    checked: checked,
    onChange: onChange
  }), /*#__PURE__*/React.createElement("label", {
    className: styles.label,
    id: value,
    htmlFor: value
  }, label));
});
RadioButton.displayName = 'RadioButton';
RadioButton.propTypes = {
  /** Value of the radio button */
  value: PropTypes.string.isRequired,

  /** Visible name on radio button */
  label: PropTypes.string.isRequired,

  /** Allows to radio to appear selected */
  checked: PropTypes.bool.isRequired,

  /** Sets the forms state to this particular radio buttons value */
  onChange: PropTypes.func.isRequired,

  /** */
  className: PropTypes.string,

  /** Disabled the radio button */
  disabled: PropTypes.bool,

  /** Current valid state */
  invalid: PropTypes.bool,
  asButton: PropTypes.bool,
  theme: PropTypes.string
};
RadioButton.defaultProps = {
  disabled: false,
  invalid: false
};

module.exports = RadioButton;
